import { language as lan_cart } from "./cart";
import { language as lan_orders } from "./orders";
import { language as lan_user } from "./user";
import { language as lan_storeProduct } from "./store-product";
import { language as lan_recaptcha } from "./recaptcha";
import { language as lan_checkOut } from "./check-out";
import { language as lan_product } from "./product";
import { language as lan_shipping } from "./shipping";
import { language as lan_address } from "./address";
import { language as lan_storeConnection } from "./store-connection";
import { language as lan_footerQPMN } from "./footer/footer-qpmn";
import { language as lan_footerQPSON } from "./footer/footer-qpson";
import { language as lan_footerNormal } from "./footer/footer-normal";
import { language as lan_menu } from "./menu/index";
import { language as lan_deliveryOrder } from "./delivery-order/index";
import { language as lan_orderBill } from "./order-bill/index";
import { language as lan_bulkOrder } from "./bulk-order";
import { language as lan_couponCode } from "./coupon-code";
import { language as lan_fileLibrary } from "./file-library";
import { language as lan_siteIntroduce } from "./introduce/index";
import { language as lan_file } from "./file/index";
import { language as lan_resourceLibrary } from "./resource-library";
import { language as lan_productPriceList } from "./product-price-list";
import { language as lan_header } from "./header/index";
import { language as lan_autoPay } from "./auto-pay/index";
import { language as lan_payment } from "./payment/index";
import { language as lan_store } from "./store";
import { language as lan_autoCombineOrder } from "./auto-combine-order";
import { language as lan_syncOrder } from "./sync-order";
import { language as lan_couponHint } from "./coupon-hint";
import { language as lan_socialNetworkLogin } from "./social-network-login";
import { language as lan_currency } from "./currency";
import { language as lan_productService } from "./product/product-service";

let language = {
    ...lan_cart,
    ...lan_orders,
    ...lan_user,
    ...lan_storeProduct,
    ...lan_recaptcha,
    ...lan_checkOut,
    ...lan_product,
    ...lan_shipping,
    ...lan_address,
    ...lan_storeConnection,
    ...lan_footerNormal,
    ...lan_footerQPMN,
    ...lan_footerQPSON,
    ...lan_menu,
    ...lan_deliveryOrder,
    ...lan_orderBill,
    ...lan_bulkOrder,
    ...lan_couponCode,
    ...lan_fileLibrary,
    ...lan_siteIntroduce,
    ...lan_file,
    ...lan_resourceLibrary,
    ...lan_productPriceList,
    ...lan_header,
    ...lan_autoPay,
    ...lan_payment,
    ...lan_store,
    ...lan_autoCombineOrder,
    ...lan_syncOrder,
    ...lan_couponHint,
    ...lan_socialNetworkLogin,
    ...lan_currency,
    ...lan_productService
};

export { language }